export default function SmallLoader({ text, iconColor, className }: any) {
    return (
        <>
            <span className={'spinner-border spinner-border-sm me-2 small-loader' + (className ? ` ${className}` : '')} style={{color: iconColor ?? "white"}} role="status" aria-hidden="true"></span>
            {text && <span>{text}</span>}
        </>
    )
}
